<script lang="ts">
  import type { PlaceType } from "../../types";
  import AppBar from "../../components/app-bar.svelte";
  import Icon from "../../components/icon.svelte";
  import { placeTypePath } from "../../support/links";
  import { filter } from "lodash-es";

  export let data;
  export let iconSize = 24;

  $: placeTypes = data.placeTypes;
  $: rootPlaceTypes = filter(placeTypes, { parentId: null });
  $: hasIcons = placeTypes.some((p: PlaceType) => p.iconSrc);
</script>

<AppBar title="placeTypes.title" />

<main style="--icon-size: {iconSize}px">
  {#each rootPlaceTypes as placeType}
    <a class="LinkGroup" href={placeTypePath(placeType)}>
      {#if placeType.iconSrc}
        <span class="GroupIcon" role="presentation">
          <Icon src={placeType.iconSrc} size={iconSize} fill={placeType.iconColor} />
        </span>
      {/if}

      <section class="GroupContent" class:with-icon={hasIcons}>
        <h2 class="GroupTitle type-h3">{placeType.label}</h2>

        {#if placeType.note}
          <p class="Note type-caption">
            {placeType.note}
          </p>
        {/if}
      </section>
    </a>
  {/each}
</main>

<style>
  main {
    --outer-left: max(env(safe-area-inset-left), var(--outer-padding));
    --outer-right: max(env(safe-area-inset-right), var(--outer-padding));
    flex: 1 1 auto;
    hyphens: auto;
    overflow: auto;
    padding-top: 8px;
    width: 100%;
  }

  .LinkGroup {
    align-items: center;
    border-bottom: 1px solid #d9d9d9;
    display: flex;
    flex-wrap: wrap;
    text-decoration: none;
    padding-block: var(--outer-padding);
    padding-left: var(--outer-left);
    padding-right: var(--outer-right);
    position: relative;
  }

  .GroupTitle {
    line-height: 1;
  }

  .Note {
    margin: calc(var(--sp) * 4) 0 0;
  }

  .GroupContent {
    flex: 1 1;
  }

  .GroupContent.with-icon {
    padding-left: calc(var(--outer-padding) + var(--icon-size));
  }

  .GroupIcon {
    left: var(--outer-left);
    position: absolute;
  }
</style>
